import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/bell-off.vue
var s = {
	name: "DtIconBellOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--bell-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Bell Off",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		fill: "currentColor"
	}, [...t[0] || (t[0] = [
		i("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M4.884 10.068a.5.5 0 0 1 .684.181.5.5 0 0 0 .865 0 .5.5 0 0 1 .865.502 1.5 1.5 0 0 1-2.595 0 .5.5 0 0 1 .181-.683Z"
		}, null, -1),
		i("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M1.5 9a.5.5 0 0 1-.283-.912l.001-.001a1.51 1.51 0 0 0 .153-.142c.113-.118.274-.318.44-.622.33-.606.689-1.646.689-3.322v-.794L.646 1.354a.5.5 0 1 1 .708-.708l10 10a.5.5 0 0 1-.708.708L8.293 9H1.5Zm1.075-1c.038-.062.076-.128.114-.198.404-.74.781-1.887.81-3.597L7.292 8H2.575Z"
		}, null, -1),
		i("path", { d: "M9.797 6.368a8.444 8.444 0 0 1-.297-2.36v-.007a3.5 3.5 0 0 0-5.442-2.917.5.5 0 0 0 .555.832A2.5 2.5 0 0 1 8.5 3.994v-.002.007-.006c-.014.891.098 1.78.333 2.639a.5.5 0 1 0 .964-.264Z" }, null, -1)
	])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=bell-off.js.map